'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWbIncandescent = function MdWbIncandescent(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 30.2l2.3-2.2 3 2.9-2.4 2.4z m4.6-12.7h5v3.4h-5v-3.4z m-8.4-7c3 1.8 5 5 5 8.6 0 5.6-4.5 10-10 10s-10-4.4-10-10c0-3.6 2-6.8 5-8.6v-8h10v8z m-18.4 7v3.4h-5v-3.4h5z m11.8 19.9v-4.9h3.2v4.9h-3.2z m-12.5-6.5l3-3 2.4 2.3-3 3.1z' })
        )
    );
};

exports.default = MdWbIncandescent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wb-incandescent.js
// module id = 3697
// module chunks = 0